"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDataChooserLoader = exports.initLoaderState = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const useKeywordSearch_1 = __importDefault(require("@opsbase/react-gql-hooks/keyword/useKeywordSearch"));
const flatten_1 = __importDefault(require("lodash/flatten"));
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const uniqBy_1 = __importDefault(require("lodash/uniqBy"));
const react_1 = require("react");
function initLoaderState(partial) {
    return Object.assign({ type: undefined, forceReal: false, filters: {}, keyword: undefined, offset: 0, limit: 25, ignoredItems: [], allowedItems: [] }, partial);
}
exports.initLoaderState = initLoaderState;
const makeVariables = (state) => {
    return Object.assign({ keyword: state.keyword, offset: state.offset || 0, limit: state.limit || 25, type: state.type }, state.filters);
};
function useDataChooserLoader(state, itemsIn) {
    const { ignoredItems, allowedItems, offset } = state;
    const variables = makeVariables(state);
    const currentItems = (0, react_1.useRef)([]);
    const result = (0, react_1.useMemo)(() => ({
        totalCount: 0,
        loading: false,
        items: [],
        refetch: doNothing_1.default,
        types: [],
        countOfTypes: [],
    }), []);
    // Note: We only use the LMSS Keyword Search if there aren't items
    const { loading, data, refetch } = (0, useKeywordSearch_1.default)({
        variables,
        context: { forceReal: state.forceReal },
        skip: itemsIn === null || itemsIn === void 0 ? void 0 : itemsIn.length,
        useExplicitPlacesToFilter: !!(variables === null || variables === void 0 ? void 0 : variables['place']),
    });
    result.loading = loading;
    result.refetch = refetch;
    if (itemsIn) {
        result.items = (0, sortBy_1.default)(itemsIn, i => i.title);
        result.totalCount = itemsIn === null || itemsIn === void 0 ? void 0 : itemsIn.length;
        if (state.keyword) {
            result.items = result.items.filter(i => i.title.toUpperCase().indexOf(state.keyword.toUpperCase()) >= 0);
        }
    }
    else if (!loading) {
        result.totalCount = data ? data.reduce((total, v) => total + v.totalCount, 0) : 0;
        result.items = (0, flatten_1.default)((data || []).map(v => v.items
            .map(item => (Object.assign(Object.assign({}, item), { type: v.type })))
            .filter(vv => !!vv)));
        result.types = data ? data.map(z => z.type) : [];
        result.countOfTypes = data ? data.map(z => z.totalCount) : [];
    }
    else {
        result.items = [];
    }
    if (!state.keyword && offset) {
        result.items = (0, uniqBy_1.default)([...currentItems.current, ...result.items], v => v.id);
    }
    if (!offset) {
        currentItems.current = [];
    }
    if (ignoredItems) {
        const ignoredIds = ignoredItems.map(z => z.id);
        result.items = result.items.filter(z => !ignoredIds.includes(z.id));
    }
    if (!!(allowedItems === null || allowedItems === void 0 ? void 0 : allowedItems.length)) {
        const allowedIds = allowedItems.map(z => z.id);
        result.items = result.items.filter(z => allowedIds.includes(z.id));
    }
    currentItems.current = result.items;
    return result;
}
exports.useDataChooserLoader = useDataChooserLoader;
exports.default = useDataChooserLoader;
